import { useEffect, useState } from "react";
import {
  Avatar,
  Col,
  Input,
  Row,
  Tabs,
  Select,
  Space,
  Empty,
  Typography,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import InboxCard from "./Component/InboxCard";
import { auth, db } from "../../../firebase";
import { collection, doc, getDocs, query, where,onSnapshot } from "firebase/firestore";
import UpComingTasks from "./Component/UpComingTasks";
import { useAuthState } from "react-firebase-hooks/auth";
import { toast } from "react-hot-toast";

const { Title } = Typography;

const onChange = (key) => {};

const handleChange = (value) => {};
const Inbox = () => {
  const [size, setSize] = useState("middle");

  const [todayTasks, setTodayTasks] = useState([]);
  const [overdueTasks, setOverdueTasks] = useState([]);
  const [upcomingTasks, setUpcomingTasks] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [filteredTodayTasks, setFilteredTodayTasks] = useState([]);
  const [filteredOverdueTasks, setFilteredOverdueTasks] = useState([]);
  const [filteredUpcomingTasks, setFilteredUpcomingTasks] = useState([]);
  const [userList, setUserList] = useState([]);
  const [user, loading] = useAuthState(auth);

  const [name, setName] = useState("");

  const fetchName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            const firstName = res.firstName;
            const lastName = res.lastName;
            setName(`${firstName} ${lastName}`);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
      // alert("An error occured while fetching user data");
    }
  };
  useEffect(() => {
    fetchName();
    console.log("test");
  }, [user, loading]);
  const avatarText = name ? name.substr(0, 2).toUpperCase() : "NA";

  const options = [
    {
      label: (
        <>
          <Avatar>{avatarText}</Avatar>{" "}
          <span style={{ marginLeft: 8 }}>{name}</span>
        </>
      ),
      value: "user",
    },
  ];
  const fetchUserList = async () => {
    try {
      const userRef = collection(db, "allUsers");

      const querySnapshot = await getDocs(userRef);
      const allItems = querySnapshot.docs.map((doc) => doc.data());
      setUserList(allItems);
    } catch (error) {}
  };

  useEffect(() => {
    const filterTasks = (tasks) => {
      return tasks.filter((task) => {
        let matchesSearch =
          !searchTerm ||
          (task.workFlowRunTitle &&
            task.workFlowRunTitle
              .toLowerCase()
              .includes(searchTerm.toLowerCase()));
        let matchesOption = !selectedOption || task.type === selectedOption;
        return matchesSearch && matchesOption;
      });
    };

    setFilteredTodayTasks(filterTasks(todayTasks));
    setFilteredOverdueTasks(filterTasks(overdueTasks));
    setFilteredUpcomingTasks(filterTasks(upcomingTasks));
  }, [searchTerm, selectedOption, todayTasks, overdueTasks, upcomingTasks]);

  useEffect(() => {
    fetchUserList();
  }, []);

  const fetchItemList = () => {
    try {
      const tasksRef = collection(db, "tasks");
      const itemListRef = doc(tasksRef, "itemList");
      const listData = collection(itemListRef, "Assigned");

      // Set up the real-time listener
      const unsubscribe = onSnapshot(listData, (querySnapshot) => {
        const allItems = querySnapshot.docs.map((doc) => {
            const data = doc.data();
            data.docId = doc.id; // Here we're adding the document ID to the item data
            return data;
        });

        const filteredTasks = allItems.filter(
          (task) => task.status !== "completed"
        );
        const filteredWorkflows = filteredTasks.filter((workflow) =>
          workflow.workFlowRunAssignee.includes(user.uid)
        );

        filteredWorkflows.forEach((workflow) => {
          workflow.workFlowRunAssignee = workflow.workFlowRunAssignee.map(
            (assigneeId) => {
              const user = userList.find((u) => u.uid == assigneeId);
              return user ? user.firstName : assigneeId;
            }
          );
        });

        const months = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];

        for (let item of filteredWorkflows) {
          const dateObj = new Date(item.workFlowRunDueDate);
          item.workFlowRunDueDate = `${
            months[dateObj.getMonth()]
          } ${dateObj.getDate()}`;
        }
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const formatDate = (dateString) => {
          const [month, day] = dateString.split(" ");
          return new Date(`${today.getFullYear()}-${month}-${day}`);
        };

        setTodayTasks(
          filteredWorkflows.filter(
            (item) =>
              formatDate(item.workFlowRunDueDate).getTime() === today.getTime()
          )
        );
        setOverdueTasks(
          filteredWorkflows.filter(
            (item) =>
              formatDate(item.workFlowRunDueDate).getTime() < today.getTime()
          )
        );
        setUpcomingTasks(
          filteredWorkflows.filter(
            (item) =>
              formatDate(item.workFlowRunDueDate).getTime() > today.getTime()
          )
        );
      });

      // Return the unsubscribe function to ensure we stop listening when the component is unmounted
      return unsubscribe;
    } catch (error) {
      console.error("Error fetching item list:", error);
    }
  };

  useEffect(() => {
    const unsubscribe = fetchItemList();
    return () => unsubscribe(); // Cleanup listener on unmount
  }, [userList]);

  const combinedTaskLength = todayTasks.length + overdueTasks.length;

  const items = [
    {
      key: "1",
      label: `Inbox (${combinedTaskLength})`,
      children: (
        <InboxCard
          todayTasks={filteredTodayTasks}
          overdueTasks={filteredOverdueTasks}
        />
      ),
    },
    {
      key: "2",
      label: `Upcoming (${upcomingTasks.length})`,
      children: <UpComingTasks upcomingTasks={filteredUpcomingTasks} />,
    },
    {
      key: "3",
      label: `My comments`,
      children: (
        <Empty
          style={{ marginTop: "10%" }}
          description={
            <div style={{ color: "rgba(0, 0, 0, 0.45)", marginTop: "20px" }}>
              <Title level={2} type="secondary">
                All clear!
              </Title>
              <p style={{ fontSize: "20px" }}>
                New comments will be shown here.
              </p>
            </div>
          }
        />
      ),
    },
  ];

  return (
    <Row>
      <Col span={24}>
        <Tabs
          defaultActiveKey="1"
          items={items}
          onChange={onChange}
          tabBarExtraContent={
            <div style={{ display: "flex" }}>
              <Space size="small">
                <Input
                  placeholder="Search"
                  prefix={<SearchOutlined />}
                  name="filterListItems"
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <Select
                  style={{
                    width: "150px",
                  }}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={[
                    {
                      value: "1",
                      label: "All",
                    },
                    {
                      value: "2",
                      label: "Approvals",
                    },
                    {
                      value: "3",
                      label: "Tasks",
                    },
                    {
                      value: "4",
                      label: "Runs",
                    },
                  ]}
                  defaultValue="1"
                />
                <Select
                  allowClear
                  showSearch
                  size={size}
                  defaultValue="Assigned to Me"
                  onChange={handleChange}
                  style={{
                    width: 200,
                  }}
                  options={options}
                />
              </Space>
            </div>
          }
        />
      </Col>
    </Row>
  );
};
export default Inbox;
